/* eslint-disable react-hooks/exhaustive-deps */
//??
import { FieldArray, Formik } from "formik";
import IconButton from "../../../../components/IconButton";
import { useState } from "react";
import InputFormik from "../../../../components/InputFormik";
import Spinner from "../../../../components/Spinner";
import { IconAdd, IconTrash } from "../../../../icons";
import InputSelect from "../../../../components/Input-select";
import { useEffect } from "react";
import useAppData from "../../../../hook/useAppData";
import { getFrequency, getConfig, postSave } from "../../service";
import { isEmailValid } from "../../../../libs/validation-email";
import { useHistory } from "react-router-dom";
import { FrequencyProps, ValuesProps } from "../../model";

import "./index.scss";
import { toastError } from "../../../../components/Toast";
import { Toaster } from "react-hot-toast";

const initialValues: ValuesProps = {
  minPercentageHours: "",
  maxPercentageHours: "",
  expirationTimePassword: "",
  emailsToCopy: [""],
};

function FormParameters(props: any) {
  const { token } = useAppData();
  const history = useHistory();
  const [initialValue, setInitialValue] = useState(initialValues);
  const [needSpinner, setNeedSpinner] = useState(true);
  const [status, setStatus] = useState(false);
  const [stateValid, setStateValid] = useState(false);

  const [frequency, setFrequency] = useState([] as FrequencyProps[]);

  useEffect(() => {
    setNeedSpinner(true);
    const promiseFrequency = getFrequency(token).then((data: FrequencyProps[]) => {
      setFrequency(data);
      return data;
    });
    const promiseConfig = getConfig(token).then((data: any) => {
      const hoursMultiplied = {
        ...data,
        maxPercentageHours: data?.maxPercentageHours * 100,
        minPercentageHours: data?.minPercentageHours * 100,
      };
      setInitialValue(hoursMultiplied);
      return data;
    });

    Promise.all([promiseFrequency, promiseConfig]).then(() => {
      setNeedSpinner(false);
    });
  }, []);

  function checkinMinPercent(props: any) {
    if (props.values.minPercentageHours > 100) {
      setTimeout(() => {
        props.values.minPercentageHours = 100;
      }, 50);
      setStatus(true);
      return true;
    }
    setTimeout(() => {
      props.values.minPercentageHours = 1;
    }, 50);
    setStatus(false);
    return false;
  }

  function checkinMaxPercent(props: any) {
    if (props.values.maxPercentageHours > 100) {
      setTimeout(() => {
        props.values.maxPercentageHours = 100;
      }, 50);
      setStatus(true);
      return true;
    }
    setTimeout(() => {
      props.values.maxPercentageHours = 0;
    }, 50);
    setStatus(false);
    return false;
  }

  function handleFormSubmit(props: any) {
    let count = 0;
    props.emailsToCopy?.forEach((emails: string) => {
      if (isEmailValid(emails)) count++;
    });
    if (stateValid) return toastError("Campos de email inválidos");
    if (count !== props.emailsToCopy?.length) return toastError("Algum campo é inválido");
    const hourFracioned = {
      ...props,
      maxPercentageHours: props.maxPercentageHours / 100,
      minPercentageHours: props.minPercentageHours / 100,
    };
    setStatus(false);

    postSave(hourFracioned, token).then((data) => {
      if (data?.ok) history.push("/");
    });
  }

  function handleConfirmClick() {
    history.push("/");
  }

  function handleValidate(value: any) {
    if (isEmailValid(value) === false) {
      setStateValid(true);
      return true;
    }
    setStateValid(false);
    return false;
  }

  return (
    <Spinner status={needSpinner}>
      <Toaster />
      <div className="parametersContainer container">
        <div className="title-form form-box-title title-parameters">
          <h1>Configurações dos Parametros</h1>
        </div>

        <Formik
          initialValues={initialValue}
          onSubmit={(values) => {
            handleFormSubmit(values);
          }}
        >
          {(props) => (
            <form className="form-container box-form" onSubmit={props.handleSubmit}>
              <div className="box-row">
                <div className="flex input-description-parameters gap">
                  <h2 className="font-source-sans-pro">Tempo de expiração</h2>
                  <p className="font-source-sans-pro  border-right-parameters">
                    Determine o tempo de expiração para os convites de login de novo usuário e troca de senha. Quando este prazo expirar, será
                    necessário enviar um novo convite ou solicitar uma nova senha.
                  </p>
                  <InputSelect
                    className="form-input select-expiration-time-password"
                    name="expirationTimePassword"
                    label=""
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    value={props.values.expirationTimePassword}
                    list={frequency}
                  />
                </div>
                <div className="flex input-description-parameters gap">
                  <h2 className="font-source-sans-pro">Horas mínimas (%)</h2>
                  <p className="font-source-sans-pro  border-right-parameters">
                    Estabeleça a porcentagem de horas mínimas trabalhadas para que o sistema envie automaticamente as notificações via e-mail, quando
                    estiver abaixo da porcentagem definida
                    <br />
                    <br />
                    Ex: (hora base = 168) - 10% = 151
                    <br />
                    17 horas de tolerância
                  </p>
                  <InputFormik
                    className="form-input input-minimum-hours"
                    label=""
                    name="minPercentageHours"
                    onChange={(event: any) => {
                      checkinMinPercent(props);
                      props.handleChange(event);
                    }}
                    onBlur={props.handleBlur}
                    value={props.values.minPercentageHours}
                    placeholder="Informe a hora mínima"
                    type="number"
                    required={true}
                    errorMessage="Valor inválido!"
                    errorStatus={checkinMinPercent(props)}
                    min="1"
                    max="100"
                  />
                </div>
                <div className="flex input-description-parameters gap">
                  <h2 className="font-source-sans-pro">Horas máximas (%)</h2>
                  <p className="font-source-sans-pro">
                    Estabeleça a procentagem máxima de horas adicionais (extras) permitidas para que o sistema envie automaticamente as notificações
                    via e-mail, quando ultrapassar essa porcentagem definida.
                    <br />
                    <br />
                    Ex: (hora base = 168) + 10% = 185
                    <br />
                    17 horas de tolerância
                  </p>
                  <InputFormik
                    className="form-input input-minimum-hours"
                    label=""
                    name="maxPercentageHours"
                    onChange={(event: any) => {
                      checkinMaxPercent(props);
                      props.handleChange(event);
                    }}
                    onBlur={props.handleBlur}
                    value={props.values.maxPercentageHours}
                    placeholder="Informe a hora máxima"
                    type="number"
                    required={true}
                    errorMessage="Valor inválido!"
                    errorStatus={checkinMaxPercent(props)}
                    min="0"
                    max="100"
                  />
                </div>
              </div>
              <FieldArray name="emailsToCopy">
                {({ insert, remove, push }) => (
                  <div className="wrap box-row">
                    {props.values.emailsToCopy?.length > 0 &&
                      props.values.emailsToCopy?.map((emailsToCopy: any, index: number) => {
                        return (
                          <div className="rowContainer">
                            <InputFormik
                              key={index}
                              className=""
                              label="E-mail"
                              name={`emailsToCopy.${index}`}
                              onChange={(e: any) => {
                                props.handleChange(e);
                              }}
                              onBlur={props.handleBlur}
                              value={props.values.emailsToCopy[index]}
                              placeholder="Digite seu e-mail"
                              type="text"
                              errorMessage="Formato de e-mail inválido!"
                              errorStatus={handleValidate(props.values.emailsToCopy[index])}
                              required={true}
                            />
                            <IconButton
                              key={index + 10}
                              icon={IconTrash}
                              className="icon-trash"
                              onClick={() => {
                                setStateValid(false);
                                remove(index);
                              }}
                            />
                          </div>
                        );
                      })}
                    <div className="addParamsContainer box-row">
                      <IconButton className="addParams" onClick={() => push("")} icon={IconAdd} />
                    </div>
                  </div>
                )}
              </FieldArray>
              <div className="form-button">
                <button className="btn" type="button" onClick={handleConfirmClick}>
                  Cancelar
                </button>
                {!status ? (
                  <button className="btn" type="submit">
                    {" "}
                    Salvar{" "}
                  </button>
                ) : (
                  <button className="disabled btn" disabled>
                    {" "}
                    Salvar{" "}
                  </button>
                )}
              </div>
            </form>
          )}
        </Formik>
      </div>
    </Spinner>
  );
}

export default FormParameters;
